import str from "@/utils/str";

export default {
  data() {
    return {
      validateErrorHandler: this.validateError,
    };
  },
  methods: {
    getValidateError(key) {
      return this.$t("message.validator." + key);
    },
    showValidateError(key) {
      this.validateErrorHandler(this.getValidateError(key));
      return false;
    },
    validateError(message) {
      this.$message.error(message);
    },
    validatePassword(password, key = "password") {
      // 密碼為空
      if (!password || !str.trim(password)) {
        return this.showValidateError(key + ".required");
      }

      //密碼長度不正確
      if (password.length < 6 || password.length > 15) {
        return this.showValidateError(key + ".length");
      }

      // 密碼必須包含英數字且不能有特殊符號
      let pattern = /^(?=\D*\d)(?=[^a-zA-Z]*[a-zA-Z])[0-9a-zA-Z]+$/i;

      if (pattern.test(password) == false) {
        return this.showValidateError(key + ".regex");
      }

      return true;
    },
    validatePasswordSpecial(password, key = "password") {
      // 密碼為空
      if (!password || !str.trim(password)) {
        return this.showValidateError(key + ".required");
      }

      let pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z0-9]{8,30}$/;
      // 密码必须包含大写、小写英文与数字，且长度至少 8 码，最多 30 码
      if (!pattern.test(password)) {
        return this.showValidateError(key + ".specialRegex");
      }

      return true;
    },
    validatePasswordChange(
      password,
      repassword,
      isSite = false,
      key = "password"
    ) {
      if (isSite) {
        if (!this.validatePasswordSpecial(password, key)) {
          return false;
        } else {
          if (password !== repassword) {
            return this.showValidateError("repassword");
          }
        }
      } else {
        if (!this.validatePassword(password, key)) {
          return false;
        } else {
          if (password !== repassword) {
            return this.showValidateError("repassword");
          }
        }
      }

      return true;
    },

    validateUsername(username, regex) {
      let r = new RegExp(regex);

      if (false == r.test(username)) {
        return this.showValidateError("username_pattern");
      }

      return true;
    },
  },
};
